import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { FormatPhoneNumberAs } from 'enumerations/format-phone-number-as';
import { PhoneDialerNotificationInterface } from '../../../app/interface/phoneDialerNotificationInterface';

@Component({
  selector: 'app-phone-dialer-notification-bar',
  templateUrl: './phone-dialer-notification-bar.component.html',
  styleUrls: ['./phone-dialer-notification-bar.component.css']
})
export class PhoneDialerNotificationBarComponent implements OnInit {
  @Input() phoneNumber: string = "";
  @Input() isoCountryCode: string = "";
  @Input() formatAs: FormatPhoneNumberAs = FormatPhoneNumberAs.International;
  @Input() prependMessage: string = "";
  @Input() appendMessage: string = "";
  @Input() dismissAfterPhoneDial: boolean = false;

  constructor(
    private snackBarRef: MatSnackBarRef<PhoneDialerNotificationBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: PhoneDialerNotificationInterface
  ) { }

  ngOnInit(): void {
    if (typeof this.data.PrependMessage !== 'undefined' && this.data.PrependMessage) {
      this.prependMessage = `${this.data.PrependMessage.trim()} `;
    }

    if (typeof this.data.AppendMessage !== 'undefined' && this.data.AppendMessage) {
      this.appendMessage = ` ${this.data.AppendMessage.trim()}`;
    }

    if (typeof this.data.PhoneNumber !== 'undefined' && this.data.PhoneNumber) {
      this.phoneNumber = `${this.data.PhoneNumber.trim()}`;
    }

    if (typeof this.data.IsoCountryCode !== 'undefined' && this.data.IsoCountryCode) {
      this.isoCountryCode = `${this.data.IsoCountryCode.trim()}`;
    }

    if (typeof this.data.FormatAs !== 'undefined' && this.data.FormatAs) {
      this.formatAs = this.data.FormatAs;
    }
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }

  dimissAfterTimedInterval(interval: number) {
    if (this.data.DismissAfterPhoneDial) {
      setInterval(() => {
        this.dismiss();
      }, interval);
      clearInterval();
    }
  }

}
